import { render } from "./Breakdown.vue?vue&type=template&id=b05efb30"
import script from "./Breakdown.vue?vue&type=script&lang=js"
export * from "./Breakdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__